module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_india-67396e2f.png";